// 封装ElementUI自定义验证
// 中文
const cnReg = /^[\u4e00-\u9fa5]+$/;
// 行政编码
const areaCodeReg = /^[1-9][0-9]{5}$/;
// 数字
const numberReg = /^\d+$|^\d+[.]?\d+$/;
// 银行卡号
const bankNumReg = /^[1-9]\d{9,29}$/;
// 手机号
const phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
// 邮箱
const emailReg = /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/;
// 企业信用代码
const companyReg = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
// 身份证
const idReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;

export default {
    // 数字验证
    validateNumber(rule, value, callback) {
        if (!numberReg.test(value)) {
            callback(new Error('请输入数字'))
        } else if (value === '') {
            callback(new Error('此处不能为空'))
        } else {
            callback()
        }
    },
    // 中文验证
    validateCn(rule, value, callback) {
        if (!cnReg.test(value)) {
            callback(new Error('请输入中文'))
        }
        callback()
    },
    // 手机号验证
    validatePhone(rule, value, callback) {
        if (!phoneReg.test(value)) {
            callback(new Error('请输入正确的手机号'))
        } else if (value === '') {
            callback(new Error('此处不能为空'))
        } else {
            callback()
        }
    },
    // 银行卡号验证
    validateBankNum(rule, value, callback) {
        if (!bankNumReg.test(value) || value === !'') {
            callback(new Error('请输入正确的银行卡号'))
        } else {
            callback()
        }
    },
    // 身份证验证
    validateId(rule, value, callback) {
        if (!idReg.test(value)) {
            callback(new Error('请输入正确证件号码'))
        }
        callback()
    },
    // 邮箱验证
    validateEmail(rule, value, callback) {
        if (!emailReg.test(value)) {
            callback(new Error('请输入正确邮箱'))
        }
        callback()
    },
    // 企业信用代码验证
    validateCorpCode(rule, value, callback) {
        if (!companyReg.test(value)) {
            callback(new Error('请输入正确企业信用代码'))
        } else if (value === '') {
            callback(new Error('此处不能为空'))
        } else {
            callback()
        }

    },
    // 行政编码验证
    validateAreaCode(rule, value, callback) {
        if (!areaCodeReg.test(value)) {
            callback(new Error('请输入正确行政编码'))
        } else if (value === '') {
            callback(new Error('请输入行政编码'))
        } else {
            callback()
        }
    }
}